import tickets from "@/router/tickets";
import settings from "@/router/settings";
import servers from "@/router/servers";
import clouds from "@/router/clouds";
import promocodes from "@/router/promocodes";
import entities from "@/router/entities";
import roles from "@/router/roles";

const routes = [
    {
        path: '/',
        name: 'index',
        component: () => import('@/pages/Index/IndexPage.vue'),
        meta: {
            requiresAuth: true,
            layout: 'content',
            title: 'Bosh sahifa',
        }
    },
    {
        path: '/login',
        name: 'login',
        component: () => import('@/pages/Index/LoginPage.vue'),
        meta: {
            requiresAuth: false,
            layout: 'navbar',
            title: 'Bosh sahifa',
        }
    },
    {
        path: '/resource-prices',
        name: 'resource_prices',
        component: () => import('@/pages/Index/ResourcePrices.vue'),
        meta: {
            need_project: false,
            requiresAuth: true,
            layout: 'content',
            title: "Resurslar narxlari",
        }
    },
    {
        path: '/payments',
        name: 'payments.index',
        component: () => import('@/pages/Payment/IndexPage.vue'),
        meta: {
            need_project: false,
            requiresAuth: true,
            layout: 'content',
            title: "Resurslar narxlari",
        }
    },
    {
        path: '/projects',
        name: 'projects.index',
        component: () => import('@/pages/Project/IndexPage.vue'),
        meta: {
            need_project: false,
            requiresAuth: true,
            layout: 'content',
            title: "Loyihalar",
        }
    },
    ...promocodes,
    ...tickets,
    ...settings,
    ...servers,
    ...clouds,
    ...entities,
    ...roles,
    {
        path: '/dashboard',
        name: 'dashboard',
        component: () => import('@/pages/Index/DashboardPage.vue'),
        meta: {
            requiresAuth: true,
            layout: 'content',
            title: "Dashboard",
        }
    },

]

export default routes